import { SelectColor } from 'components/colors/component'
import { RasaContext } from 'context'
import * as GenericRedux from 'generic/genericRedux'
import * as React from 'react'
import { Input } from 'reactstrap'
import { EmailAttributes, getAttribute } from '../constants'
import { EditSectionProps } from '../components'
import '../styles.scss'

type TopicPreferencesEditorState = Record<string, never>

type TopicPreferencesEditorProps = GenericRedux.AllComponentPropsWithModal<any> & EditSectionProps

export class TopicPreferencesEditor extends React.Component<TopicPreferencesEditorProps, TopicPreferencesEditorState> {
  public static contextType = RasaContext

  constructor(props: TopicPreferencesEditorProps) {
    super(props)
    this.state = {}
  }

  public render() {
    return (
      <div className="topic-preferences-editor">
        <div className="go-back" onClick={() => this.goBack()}>&lt; &nbsp; Go back</div>
        <span className="title">Topic Preferences</span>
        
        <div className="section">
          <div className="block">
            <div className="title">Settings</div>
            <div className="topic-preferences-options">
                <div>
                  <span>Heading</span>
                  <Input 
                    value={getAttribute(this.props.data, EmailAttributes.topicPreferenceHeading) || 'Customize Your Content'}
                    maxLength={100}
                    onChange={(e) => this.props.onChange(EmailAttributes.topicPreferenceHeading, e.target.value)}/>
                </div>
                <div>
                  <span>Description</span>
                  <Input 
                    value={getAttribute(this.props.data, EmailAttributes.topicPreferenceDescription) || 'Select your topic preferences to receive more personalized content.'}
                    maxLength={200}
                    onChange={(e) => this.props.onChange(EmailAttributes.topicPreferenceDescription, e.target.value)}/>
                </div>
                <div>
                  <span>CTA Button Text</span>
                  <Input 
                    value={getAttribute(this.props.data, EmailAttributes.topicPreferenceCTAText) || 'Set Preferences'}
                    maxLength={50}
                    onChange={(e) => this.props.onChange(EmailAttributes.topicPreferenceCTAText, e.target.value)}/>
                </div>
                
                <br />
                <div className="small-title">Background Color</div>
                <SelectColor
                  key="topicPreferenceBackgroundColor"
                  className="topicPreferenceBackgroundColor"
                  selectColor={(c: string) => this.props.onChange(EmailAttributes.topicPreferenceBackgroundColor, c)}
                  color={this.props.data[EmailAttributes.topicPreferenceBackgroundColor] || '#f5f5f5'}
                />
                
                <br />
                <div className="small-title">Text Color</div>
                <SelectColor
                  key="topicPreferenceTextColor"
                  className="topicPreferenceTextColor"
                  selectColor={(c: string) => this.props.onChange(EmailAttributes.topicPreferenceTextColor, c)}
                  color={this.props.data[EmailAttributes.topicPreferenceTextColor] || '#000000'}
                />
                
                <br />
                <div className="small-title">Button Color</div>
                <SelectColor
                  key="topicPreferenceButtonColor"
                  className="topicPreferenceButtonColor"
                  selectColor={(c: string) => this.props.onChange(EmailAttributes.topicPreferenceButtonColor, c)}
                  color={this.props.data[EmailAttributes.topicPreferenceButtonColor] || '#0066cc'}
                />
                
                <br />
                <div className="small-title">Button Text Color</div>
                <SelectColor
                  key="topicPreferenceButtonTextColor"
                  className="topicPreferenceButtonTextColor"
                  selectColor={(c: string) => this.props.onChange(EmailAttributes.topicPreferenceButtonTextColor, c)}
                  color={this.props.data[EmailAttributes.topicPreferenceButtonTextColor] || '#ffffff'}
                />
              </div>
          </div>
        </div>
      </div>
    )
  }

  private goBack() {
    if (this.props.select) {
      this.props.select('layout')
    }
  }

  // When the module is added to the layout, it's always enabled
}